import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const all = () => {
    return api.get(`/users/all`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de todos os usuários')
        })
}

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/users?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de usuários')
        })
}

const find = (id) => {
    return api.get(`/users/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o usuário')
        })
}

const findByCompanie = (id) => {
    return api.get(`/users/bycompany/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar os usuários da empresa')
        })
}

const store = (data) => {
    return api.post(`/users`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível cadastrar o usuário')
        })
}

const update = (data) => {
    return api.put(`/users/${data.id}`, data)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível atualizar o usuário')
        })
}

const destroy = (id) => {
    return api.delete(`/users/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível excluir o usuário')
        })
}

export default {
    all,
    findAll,
    find,
    findByCompanie,
    store,
    update,
    destroy
}
